/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * IN_PROGRESS until finished; FINISHED once finished with every question answered; EXPIRED when the time ran out first — then the questions without an answer count as wrong; INVALIDATED when an administrator ruled that it does not count.
 * @export
 * @enum {string}
 */

export const AttemptStatusDto = {
    InProgress: 'IN_PROGRESS',
    Finished: 'FINISHED',
    Expired: 'EXPIRED',
    Invalidated: 'INVALIDATED'
} as const;

export type AttemptStatusDto = typeof AttemptStatusDto[keyof typeof AttemptStatusDto];



